<template>
  <div>

    <BackButton v-if="$route.name !== 'permits'" :namedRoutes="{ permits: $t('nav.permits'), permit: $t('common.parking_permit')}"></BackButton>

    <add-edit-permit-view v-if="$route.name !== 'permit'"></add-edit-permit-view>
    <permit-details v-if="$route.name === 'permit'" />

    <BackButton v-if="$route.name !== 'permits'" :namedRoutes="{ permits: $t('nav.permits'), permit: $t('common.parking_permit')}"></BackButton>

  </div>
</template>

<script>
import BackButton from 'common/BackButton';
import PermitDetails from 'permits/PermitDetails';
import AddEditPermitView from './AddEditPermitView';

export default {
  components: {
    BackButton,
    AddEditPermitView,
    PermitDetails,
  },
  data() {
    return {
      routes: null,
    };
  },
  created() {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/permits/MainView.vue